<template>
  <v-layout wrap>

    <v-flex xs12 v-if="plans.length === 0">
      <small class="text-center mx-auto" >No hay planes disponibles</small>
    </v-flex>

    <template v-else>
      <v-flex xs12 md4 xl3 pa-1 v-for="(plan, i) in plans" :key="i">
        <plan-card @click:edit="$emit('click:edit', plan)" :internal="internal" :plan="plan"/>
      </v-flex>
    </template>

  </v-layout>
</template>

<script>
import PlanCard from "@/components/admin/plans/PlanCard";
export default {
name: "PlansList",
  components: {PlanCard},
  props:{
    internal:{
      type: Boolean,
      default: false
    },
    plans: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
